//
//
//
//
//
//
//
//
//

export default {
  name: 'tag-item',
  props: {
    mainText: {
      type: String,
      default: ''
    },
    iconType: {
      oneOf: ['price', 'time', 'buy-red', 'buy-white'],
      type: String
    },
    hideIcon: {
      type: Boolean,
      default: false
    },
    transFormStyle: {
      type: Boolean,
      default: false
    }
  }
};